module.exports = __webpack_public_path__ + "static/media/20201129_215101_475_IMG_1888.86c387a3.jpg";